<div class="settings-container grid-builder-settings-container">
  <div class="settings-header">
    <div class="grid-builder-header">
      <h6>Settings</h6>
      <rappider-button text="Edit Grid JSON Data"
                       [icon]="{name: 'fa-solid fa-brackets-curly'}"
                       (click)="onEditJsonData()">
      </rappider-button>
    </div>
    <hr>
    <nz-tabset #gridSettingsTabs
               nzType="card"
               [nzSelectedIndex]="activeTabIndex"
               [(nzSelectedIndex)]="activeTabIndex">
      <nz-tab [nzTitle]="columnsSettingsTabIconTemplate">
        <ng-template #columnsSettingsTabIconTemplate>
          <ng-container *ngTemplateOutlet="tabIcon;context:{
            icon: 'fa-light fa-table-columns',
            title: activeTabIndex === 0 ? 'Columns Settings' : '',
            tooltip: 'Columns Settings',
            tooltipPlacement: 'top'
          }"></ng-container>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="listActionsTabIconTemplate">
        <ng-template #listActionsTabIconTemplate>
          <ng-container *ngTemplateOutlet="tabIcon;context:{
            icon: 'fa-light fa-list',
            title: activeTabIndex === 1 ? 'List Actions' : '',
            tooltip: 'List Actions',
            tooltipPlacement: 'top'
          }"></ng-container>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="itemActionsTabIconTemplate">
        <ng-template #itemActionsTabIconTemplate>
          <ng-container *ngTemplateOutlet="tabIcon;context:{
            icon: 'fa-light fa-ballot',
            title: activeTabIndex === 2 ? 'Item Actions' : '',
            tooltip: 'Item Actions',
            tooltipPlacement: 'top'
          }"></ng-container>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="gridSettingsTabIconTemplate">
        <ng-template #gridSettingsTabIconTemplate>
          <ng-container *ngTemplateOutlet="tabIcon;context:{
            icon: 'fa-light fa-grid',
            title: activeTabIndex === 3 ? 'Grid Settings' : '',
            tooltip: 'Grid Settings',
            tooltipPlacement: 'top'
          }"></ng-container>
        </ng-template>
      </nz-tab>
    </nz-tabset>
  </div>

  <div class="settings-tabs-content">
    <div class="tab-pane-content"
         *ngIf="activeTabIndex === 0">
      <div *ngIf="editingColumn; else noColumnSelected">
        <div class="form-area">
          <div class="config-input-area">
            <div class="control-area">
              <nz-form-label nzRequired>
                Title
              </nz-form-label>
              <div class="input">
                <rappider-textbox [(ngModel)]="editingColumn.title"
                                  (blur)="onColumnFieldBlur()"
                                  (ngModelChange)="generateFieldNameFromTitle(); onColumnFieldBlur()"></rappider-textbox>
                <small *ngIf="tempValueSubmitted && !editingColumn.title"
                       class="error">*This field can't be empty</small>
              </div>
            </div>
            <div class="control-area">
              <nz-form-label nzRequired>
                Field Name
              </nz-form-label>
              <div class="input">
                <rappider-textbox [(ngModel)]="editingColumn.fieldName"
                                  (blur)="onColumnFieldBlur()"></rappider-textbox>
                <small *ngIf="!isFieldNameUnique() && tempValueSubmitted"
                       class="error">
                  *Field Name must be unique.
                </small>
                <br>
                <small *ngIf="tempValueSubmitted && !editingColumn.fieldName"
                       class="error">*This field can't be empty</small>
              </div>
            </div>
            <div class="control-area">
              <nz-form-label nzRequired>
                Type
              </nz-form-label>
              <div class="input">
                <rappider-select [(ngModel)]="editingColumn.type"
                                 [options]="typeSelectOptions"
                                 (blur)="onColumnFieldBlur()"
                                 (ngModelChange)="onColumnFieldBlur()"></rappider-select>
                <small *ngIf="tempValueSubmitted && !editingColumn.type"
                       class="error">*This field can't be empty</small>
              </div>
            </div>
            <div class="control-area">
              <nz-form-label>
                Width (px)
              </nz-form-label>
              <div class="input">
                <rappider-number-input [(ngModel)]="editingColumn.width"
                                       [min]="50"
                                       [max]="1000"
                                       placeholder="Auto"
                                       (blur)="onColumnFieldBlur()"
                                       (ngModelChange)="onColumnFieldBlur()"></rappider-number-input>
              </div>
            </div>
            <div class="control-area">
              <nz-form-label>
                Visible
              </nz-form-label>
              <div class="input">
                <rappider-switch [(ngModel)]="editingColumn.visible"
                                 (ngModelChange)="onColumnFieldBlur()"></rappider-switch>
              </div>
            </div>
            <div *ngIf="editingColumn.type === CrudViewColumnType.InputTemplate"
                 class="control-area">
              <nz-form-label nzRequired>
                Input Template Type
              </nz-form-label>
              <div class="input">
                <rappider-select [(ngModel)]="editingColumn.inputTemplateType"
                                 [options]="inputTemplateTypeSelectOptions"
                                 (blur)="onColumnFieldBlur()"
                                 (ngModelChange)="onColumnFieldBlur()"></rappider-select>
                <small *ngIf="tempValueSubmitted && !editingColumn.inputTemplateType"
                       class="error">*This field can't be empty</small>
              </div>
            </div>
          </div>
          <div class="button-area">
          </div>
        </div>
      </div>
    </div>

    <div class="tab-pane-content"
         *ngIf="activeTabIndex === 1">
      <rappider-actions-input [(ngModel)]="value.listActions"
                              (ngModelChange)="onItemsChange()"></rappider-actions-input>
    </div>

    <div class="tab-pane-content"
         *ngIf="activeTabIndex === 2">
      <rappider-actions-input [(ngModel)]="value.itemActions"
                              (ngModelChange)="onItemsChange()"></rappider-actions-input>
    </div>

    <div class="tab-pane-content"
         *ngIf="activeTabIndex === 3">
      <div>
        <div class="form-control-area">
          <div class="label">
            <span>
              <b>
                Content:
              </b>
            </span>
          </div>
          <rappider-textbox [ngModel]="value?.title?.content"
                            (ngModelChange)="onTitleContentChange($event)"></rappider-textbox>
        </div>
        <div class="form-control-area">
          <div class="label">
            <span>
              <b>
                Type:
              </b>
            </span>
          </div>
          <rappider-select [ngModel]="value?.title?.type"
                           [options]="headingTypeOptions"
                           (ngModelChange)="onTitleTypeChange($event)"></rappider-select>
        </div>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Searchable:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.searchable"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div *ngIf="value.searchable"
           class="form-control-area">
        <div class="label">
          <span>
            <b>
              Search Placeholder:
            </b>
          </span>
        </div>
        <rappider-textbox [(ngModel)]="value.searchPlaceholder"
                          (ngModelChange)="onItemsChange()"></rappider-textbox>
      </div>
      <div *ngIf="value.searchable"
           class="form-control-area">
        <div class="label">
          <span>
            <b>
              Search Field:
            </b>
          </span>
        </div>
        <rappider-string-array [(ngModel)]="value.multipleSearchFields"
                               (ngModelChange)="onItemsChange()"></rappider-string-array>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Selectable:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.selectable"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div *ngIf="value.selectable"
           class="form-control-area">
        <div class="label">
          <span>
            <b>
              Enable Multiple Selection:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.enableMultipleSelection"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Selectable Column Visibility:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.columnVisibilitySelectable"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Size:
            </b>
          </span>
        </div>
        <rappider-select [(ngModel)]="value.size"
                         [options]="inputSizeOptions"
                         (ngModelChange)="onItemsChange()"></rappider-select>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Date Format:
            </b>
          </span>
        </div>
        <rappider-select [(ngModel)]="value.dateFormat"
                         [options]="dateFormatOptions"
                         (ngModelChange)="onItemsChange()"></rappider-select>
      </div>

      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Orderable:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.orderable"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Show Pagination:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.showPagination"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div *ngIf="value.showPagination"
           class="form-control-area">
        <div class="label">
          <span>
            <b>
              Page Size:
            </b>
          </span>
        </div>
        <rappider-number-input [(ngModel)]="value.pageSize"
                               (ngModelChange)="onItemsChange()"></rappider-number-input>
      </div>
      <div *ngIf="value.showPagination"
           class="form-control-area">
        <div class="label">
          <span>
            <b>
              Front Pagination:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.nzFrontPagination"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Filterable:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.filterable"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>
      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Length of Item Actions:
            </b>
          </span>
        </div>
        <rappider-number-input [(ngModel)]="value.itemActionsLength"
                               (ngModelChange)="onItemsChange()"></rappider-number-input>
      </div>

      <div class="form-control-area">
        <div class="label">
          <span>
            <b>
              Freeze First Column:
            </b>
          </span>
        </div>
        <rappider-switch [(ngModel)]="value.freezeFirstColumn"
                         (ngModelChange)="onItemsChange()"></rappider-switch>
      </div>

      <!-- Column Styles Section -->
      <div class="form-control-area field-formatting-area" *ngIf="value && value.columns && value.columns.length > 0">
        <div class="label">
          <span><b>Column Styles:</b></span>
        </div>
        <div class="columns-list-container">
          <!-- All Columns Row -->
          <rappider-field-formatting-toolbar
            [field]="null"
            [label]="'All Columns'"
            [context]="FieldFormattingContext.ALL_FIELDS"
            [isAllFields]="true"
            [currentTextColor]="getAllColumnsTextColor()"
            [currentStyle]="getAllColumnsTextStyle()"
            [textColorOptions]="textColorOptions"
            [styleButtons]="styleButtons"
            [isTextColorActive]="hasAllColumnsSameTextColor() && getAllColumnsTextColor() && getAllColumnsTextColor() !== TextColorType.Default"
            [textColorValue]="getTextColorValue(getAllColumnsTextColor())"
            [currentBackgroundColor]="getAllColumnsBackgroundColor()"
            [isBackgroundColorActive]="hasAllColumnsSameBackgroundColor() && getAllColumnsBackgroundColor() && getAllColumnsBackgroundColor() !== TextColorType.Default"
            [backgroundColorValue]="getTextColorValue(getAllColumnsBackgroundColor())"
            (textColorChange)="onColumnFormattingColorChange(FieldFormattingContext.ALL_FIELDS, $event)"
            (backgroundColorChange)="onColumnFormattingBackgroundColorChange(FieldFormattingContext.ALL_FIELDS, $event)"
            (styleToggle)="onColumnFormattingStyleToggle(FieldFormattingContext.ALL_FIELDS, $event.styleType)"
            (contextSet)="setCurrentColumnContext($event)">
          </rappider-field-formatting-toolbar>

          <!-- Individual Column Rows -->
          <rappider-field-formatting-toolbar
            *ngFor="let column of value.columns; trackBy: trackByFieldName"
            [field]="null"
            [label]="column.title"
            [context]="column.fieldName"
            [currentTextColor]="getColumnTextColor(column)"
            [currentStyle]="getColumnTextStyle(column)"
            [textColorOptions]="textColorOptions"
            [styleButtons]="styleButtons"
            [isTextColorActive]="getColumnTextColor(column) && getColumnTextColor(column) !== TextColorType.Default"
            [textColorValue]="getTextColorValue(getColumnTextColor(column))"
            [currentBackgroundColor]="getColumnBackgroundColor(column)"
            [isBackgroundColorActive]="getColumnBackgroundColor(column) && getColumnBackgroundColor(column) !== TextColorType.Default"
            [backgroundColorValue]="getTextColorValue(getColumnBackgroundColor(column))"
            (textColorChange)="onColumnFormattingColorChange(column.fieldName, $event)"
            (backgroundColorChange)="onColumnFormattingBackgroundColorChange(column.fieldName, $event)"
            (styleToggle)="onColumnFormattingStyleToggle(column.fieldName, $event.styleType)"
            (contextSet)="setCurrentColumnContext($event)">
          </rappider-field-formatting-toolbar>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noColumnSelected>
    <rappider-alert [type]="GridBuilderEmptyInfoAlertConfig.type"
                    [description]="GridBuilderEmptyInfoAlertConfig.description"
                    [closeable]="GridBuilderEmptyInfoAlertConfig.closeable"
                    [showIcon]="GridBuilderEmptyInfoAlertConfig.showIcon"></rappider-alert>
  </ng-template>

  <!-- TAB ICON TEMPLATE -->
  <ng-template #tabIcon
               let-icon="icon"
               let-title="title"
               let-tooltip="tooltip"
               let-tooltipPlacement="tooltipPlacement">
    <div class="tab-icon"
         [nzTooltipTitle]="tooltip"
         [nzTooltipPlacement]="tooltipPlacement || 'bottom'"
         nz-tooltip>
      <i [ngClass]="icon"></i>
      <p *ngIf="title">{{ title }}</p>
    </div>
  </ng-template>
  <!-- / TAB ICON TEMPLATE -->
